import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import NoticeModal from "views/components/NoticeModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../../components/UpdateUi/CustomeSelect";

const WeightageScoreEligibleControllerCreate = ({
  classes,
  WeighageAllocationShow,
  weighageId,
  setWeighageId,
  onClose,
  rawData,
}) => {
  const navigate = useNavigate();
  const [rangeFrom,setRangeFrom]=useState("")
  const [rangeFromState,setRangeFromState]=useState("")
  const [rangeTo,setRangeTo]=useState("")
  const [rangeToState,setRangeToState]=useState("")
  const [eligibility, setEligibility] = useState("");
  const [eligibilityState, setEligibilityState] = useState(false);
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [isValid, setIsValid] = useState(true);

  const [callInProgress, setCallInProgress] = useState(false);
  const eligibilityList = [
    { code: "2", name: "2" },
    { code: "1.5", name: "1.5" },
    { code: "1", name: "1" },
    { code: "0.5", name: "0.5" },
    { code: "0", name: "0" },
  ];
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (eligibility === "") {
      setEligibilityState(true);
    } else {
      setEligibilityState(false);
    }
    if (rangeFrom === "") {
        setRangeFromState(true);
      } else {
          setRangeFromState(false);
      }
      if (rangeTo === "") {
        setRangeToState(true);
      } else {
        setRangeToState(false);
      }
    if (rangeFrom === "" || eligibility === "" || rangeTo === "") {
      setIsValid(false)
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if (weighageId) {
      GetData();
    }
  }, []);

  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_FIND_BY_ID + weighageId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      setNoticeModalErrMsg(result?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
    } else {
      setEligibility(result?.data?.eligibility);
      setRangeFrom(result?.data?.scoreRangeFrom)
      setRangeTo(result?.data?.scoreRangeTo)
    }
  };

  const handleCreateSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
            eligibility: eligibility,
            scoreRangeFrom: parseInt(rangeFrom),
            scoreRangeTo: parseInt(rangeTo),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        setNoticeModalErrMsg(res?.data?.user_description);
        setNoticeModalHeaderMsg("Error");
        setNoticeModal(true);
        return;
      } else {
        onClose("create");
        WeighageAllocationShow(true);
      }
    }
  };

  const handleEditSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_UPDATE + weighageId,
        method: "PUT",
        authToken: authToken,
        data: {
            eligibility: eligibility,
            scoreRangeFrom: parseInt(rangeFrom),
            scoreRangeTo: parseInt(rangeTo),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        setNoticeModalErrMsg(res?.data?.user_description);
        setNoticeModalHeaderMsg("Error");
        setNoticeModal(true);
        return;
      } else {
        onClose("update");
        WeighageAllocationShow(true);
      }
    }
  };
  const handleCancel = () => {
    WeighageAllocationShow(true);
    setWeighageId("");
  };

  const handleInputChange = (e,name) => {
    const enteredValue = e;
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            weighageId ? "Edit Weightage Eligible Score" : "Create Weightage Eligible Score"
          }
          button1=" Save"
          button2=" Cancel"
          button1click={weighageId ? handleEditSubmit : handleCreateSubmit}
          button2click={handleCancel}
          // disabled1={isValid}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes?.inputContainer}>
        <Grid container className={classes?.inputFieldContainer}>
          <Grid xs={12} sm={6} md={4} className={classes?.fieldContaienr}>
            <CustomTextField
              label="Score Range From"
              required
              error={rangeFromState}
              id="lp_branch_code"
              value={rangeFrom || ""}
              setState={setRangeFrom}
              setError={setRangeFromState}
              setBlur={!isValid}
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} className={classes?.fieldContaienr}>
            <CustomTextField
              label="Score Range To"
              required
              error={rangeToState}
              id="lp_branch_code"
              value={rangeTo || ""}
              setState={setRangeTo}
              setError={setRangeToState}
              setBlur={!isValid}
            />
          </Grid>
          <Grid xs={12} sm={12} md={4} className={classes?.fieldContaienr}>
            <CustomSelectNew
              label="Eligibility*"
              error={eligibilityState}
              value={eligibility}
              setState={setEligibility}
              data={eligibilityList}
              setError={setEligibilityState}
              type = "TYPE"
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        noticeModalErrMsg={noticeModalErrMsg}
        closeModal={closeNoticeModal}
      />
    </Grid>
  );
};

WeightageScoreEligibleControllerCreate.propTypes = {
  classes: PropTypes.object,
};

export default WeightageScoreEligibleControllerCreate;
